import { Control } from 'react-hook-form';

import { FormControl, FormField, FormItem } from '@/components/ui/form';
import { Input } from '@/components/ui/input';

import type { NotificationTemplateResponse, TemplateSectionKey } from '../types';

const LANGUAGE_NAMES: Record<string, string> = {
  en: 'English',
  'pt-BR': 'Portuguese (Brazil)',
  pt: 'Portuguese',
  zh: 'Chinese',
  fr: 'French',
  nl: 'Dutch',
  es: 'Spanish',
  ko: 'Korean',
  ja: 'Japanese',
  de: 'German',
  it: 'Italian',
};

interface Props {
  sectionKey: TemplateSectionKey;
  title: string;
  control: Control;
  templates: NotificationTemplateResponse[];
}

export const TemplateSection = ({ sectionKey, title, control, templates }: Props) => {
  return (
    <div className="flex flex-col gap-3">
      <h2 className="text-base font-semibold text-zinc-50">{title}</h2>
      <div className="border border-zinc-800 rounded-md overflow-hidden">
        <table className="w-full">
          <thead>
            <tr className="border-b border-zinc-800 bg-zinc-900">
              <th className="text-left px-4 py-2 text-sm font-medium text-zinc-400 w-48">
                Language
              </th>
              <th className="text-left px-4 py-2 text-sm font-medium text-zinc-400">
                Text
              </th>
            </tr>
          </thead>
          <tbody>
            {templates.map((template, index) => (
              <tr
                key={template.lang}
                className="border-b border-zinc-800 last:border-b-0"
              >
                <td className="px-4 py-2 text-sm text-zinc-300">
                  {LANGUAGE_NAMES[template.lang] ?? template.lang}
                </td>
                <td className="px-2 py-1">
                  <FormField
                    control={control}
                    name={`templates.${index}.${sectionKey}`}
                    render={({ field }) => (
                      <FormItem>
                        <FormControl>
                          <Input
                            {...field}
                            className="h-9 bg-transparent border-transparent focus-visible:ring-0 focus-visible:border-zinc-700"
                          />
                        </FormControl>
                      </FormItem>
                    )}
                  />
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};
